var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#060E41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m65.736 41.988-14.759 8.548a1.98 1.98 0 0 1-1.955 0l-14.758-8.548c-1.054-.613-1.322-2.05-.517-2.952a6.9 6.9 0 0 1 1.859-1.514l10.388-5.75c2.223-1.246 5.827-1.246 8.05 0l10.388 5.75c.671.364 1.304.901 1.86 1.514.766.901.498 2.339-.556 2.952M48.908 54.102v13.072c0 1.456-1.476 2.414-2.78 1.782-3.948-1.936-10.599-5.558-10.599-5.558-2.338-1.323-4.255-4.658-4.255-7.399v-9.89c0-1.514 1.591-2.472 2.895-1.725l13.78 7.993c.575.364.959 1.016.959 1.725M51.093 54.102v13.072c0 1.456 1.476 2.414 2.779 1.782 3.948-1.936 10.6-5.558 10.6-5.558 2.337-1.323 4.254-4.658 4.254-7.399v-9.89c0-1.514-1.59-2.472-2.894-1.725l-13.78 7.993a2.06 2.06 0 0 0-.96 1.725"
  })));
};
export default SvgBox;